module.exports = __webpack_public_path__ + "img/网站3-78.f0218174.png";